import type { AxiosInstance, AxiosResponse, AxiosStatic } from "axios";
import { client } from "./gen/client.gen";

export type ApiAxios = AxiosInstance | AxiosStatic;

export const configureApiClient = (axios: ApiAxios) => {
  client.setConfig({ axios });
  return client;
};

export const unwrapApiResponse = async <T>(request: Promise<AxiosResponse<T>>) => {
  const { data } = await request;
  return data;
};
